import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TTL = 60000;

let cache = null;
let fetchedAt = 0;
let inflight = null;
const listeners = new Set();

const load = () => {
  if (inflight) return inflight;
  inflight = axios
    .get(`${API}/stock`)
    .then((r) => {
      cache = r.data || {};
      fetchedAt = Date.now();
    })
    .catch(() => {
      cache = cache || {};
    })
    .then(() => {
      inflight = null;
      const snapshot = { ...cache };
      listeners.forEach((fn) => fn(snapshot));
    });
  return inflight;
};

export const useStockOverrides = () => {
  const [ov, setOv] = useState(cache);
  useEffect(() => {
    listeners.add(setOv);
    if (!cache || Date.now() - fetchedAt > TTL) load();
    else setOv(cache);
    return () => listeners.delete(setOv);
  }, []);
  return ov || {};
};

let drops = null;
let dropsAt = 0;
let dropsInflight = null;
const dropListeners = new Set();

const loadDrops = () => {
  if (dropsInflight) return dropsInflight;
  dropsInflight = axios
    .get(`${API}/drops`)
    .then((r) => {
      drops = r.data || {};
      dropsAt = Date.now();
    })
    .catch(() => {
      drops = drops || {};
    })
    .then(() => {
      dropsInflight = null;
      const snapshot = { ...drops };
      dropListeners.forEach((fn) => fn(snapshot));
    });
  return dropsInflight;
};

export const useDropDates = () => {
  const [d, setD] = useState(drops);
  useEffect(() => {
    dropListeners.add(setD);
    if (!drops || Date.now() - dropsAt > TTL) loadDrops();
    else setD(drops);
    return () => dropListeners.delete(setD);
  }, []);
  return d || {};
};

export const applyStock = (p, ov) => (p && ov[p.slug] && ov[p.slug] !== p.status ? { ...p, status: ov[p.slug] } : p);
